import loadable from "@loadable/component";
import LinearProgress from "@material-ui/core/LinearProgress";

/**
 * Dynamically loaded version of `ReportPage`.
 */
const LoadablePage = loadable(() => import(/* webpackChunkName: "Report" */ "."), {
  fallback: <LinearProgress />,
});

export default LoadablePage;
